import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import LiveStatsSection from './components/LiveStatsSection';
import FeaturedTalentSection from './components/FeaturedTalentSection';
import TrustIndicatorSection from './components/TrustIndicatorSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import ClientSuccessSection from './components/ClientSuccessSection';
import ServicesOverviewSection from './components/ServicesOverviewSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <HeroSection />
        <LiveStatsSection />
        <FeaturedTalentSection />
        <TrustIndicatorSection />
        <ClientSuccessSection />
        <SuccessStoriesSection />
        <ServicesOverviewSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Homepage;